import { render, staticRenderFns } from "./Prob3.vue?vue&type=template&id=053fe5f1&scoped=true&"
import script from "./Prob3.vue?vue&type=script&lang=js&"
export * from "./Prob3.vue?vue&type=script&lang=js&"
import style0 from "./Prob3.vue?vue&type=style&index=0&id=053fe5f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053fe5f1",
  null
  
)

export default component.exports